import { createContext, useContext } from 'react'
import { DEFAULT_GRADE_CONFIG, type GymGradeConfig } from '@structural-climbing/validation'

// A defaulted context (never throws) so any member screen can read the viewed
// gym's configured grade scale without prop drilling, and still render in
// isolation (tests) with the legacy 1..8. GymLayout feeds it the config from
// the gym's /gym-info branding.
export const GymGradeConfigContext = createContext<GymGradeConfig>(DEFAULT_GRADE_CONFIG)

export function useGymGradeConfig(): GymGradeConfig {
  return useContext(GymGradeConfigContext)
}
